import React, { Component } from "react";
import { Link } from 'react-router-dom'
import MQSGUtil from "../../../components/mqsgUtil";
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import Timeline from "highcharts/modules/timeline.js"
import Nodata from "highcharts/modules/no-data-to-display";
import moment from "moment"
import { inArray } from "jquery";
Nodata(Highcharts);
Timeline(Highcharts);
export default class DataModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalData: [
               
                {
                    id: 1,
                    headText: "Hang Seng Index",
                    profileImg: "/img/education/sflag_hk.svg",
                    text: "The Hang Seng Index (“HSI”) is the most widely quoted performance indicator of the Hong Kong share market, and one of the most watched indexes in the region. Comprising 50 of the largest shares on the Hong Kong exchange, it tracks the movement in the Hong Kong market and is very closely linked to the Chinese economy. Many investors across the world use the HSI as a proxy to invest into China.",
                    img1: "/img/education/HSI1.svg",
                    img2: "/img/education/HSI2.svg",
                    img3: "/img/education/HSI3.svg",
                    text1: "Comprises 50",
                    text2: "of the largest and most liquid stocks listed on the HKEX",
                    text3: "Captures major sectors",
                    text4: "with constituents grouped into Finance, Utilities, Properties, and Commerce and Industry",
                    text5: "Tracks the HK market",
                    text6: "and is closely linked to the Chinese economy",
                    tableHeading: "HSI"
                },
                {
                    id: 2,
                    headText: "Hang Seng TECH Index",
                    profileImg: "/img/education/sflag_hk.svg",
                    text: `The Hang Seng TECH Index (“HSTECH”) comprises the largest companies listed on the Hong Kong Stock Exchange which have high exposure in selected technology themes. First launched in July 2020, the more notable constituents include well-known names such as Alibaba, Tencent, Meituan and Xiaomi (commonly referred to as ‘ATMX’) which have a combined weight of more than 30%. Investors will be able to gain exposure to these heavyweights as well as a diverse spectrum of themes within the tech sector including internet, fintech, cloud, e-commerce and digital while minimizing any single stock specific risk.<br/><br/>View more information on the HSTECH <a target=${"_blank"} href=${"/my/warrant-education/gain-exposure"}>here</a>.<br/></br>`,
                    img1: "/img/education/HSTECH1.svg",
                    img2: "/img/education/HSTECH2.svg",
                    img3: "	/img/education/HSTECH3.svg",
                    text1: "Higher volatility",
                    text2: "than the HSI on average",
                    text3: "Ease of access",
                    text4: "Trade warrants on Bursa using your existing trading account",
                    text5: "Broad coverage",
                    text6: "of the technology sector, including the popular ATMX!",
                    tableHeading: "HSTECH"
                },
                {
                    id: 3,
                    headText: "SPDR® Gold Shares ETF",
                    profileImg: "/img/education/singapore_flag_svg.png",
                    text: "The SPDR® Gold Shares (“GLDSP”; stock code O87) is an exchange traded fund (ETF) listed on the Singapore Exchange (SGX) and traded in US dollars. It is designed to reflect the price performance of the gold bullion (less the Trust's expenses) and provides investors with a convenient way to gain exposure to the gold market without having to purchase, store, or take physical delivery of gold, while allowing shares to be bought and sold on the exchange like a stock.",
                    img1: "/img/education/2840HK_1.svg",
                    img2: "/img/education/2840HK_z.svg",
                    img3: "/img/education/2840HK_2.svg",
                    text1: "One of the largest Gold ETFs",
                    text2: "in the world that tracks the price of gold bullion, since its launch in November 2004",
                    text3: "Easily accessible",
                    text4: "The GLDSP is listed on the SGX, with price data easily available through SGX's website and various public platforms",
                    text5: "Potential hedge against inflation",
                    text6: "Gold has historically been viewed by investors as a potential hedge and safe-haven asset during periods of market volatility and uncertainty. The GLDSP provides a relatively cost-efficient way to gain exposure to the gold market and may provide diversification benefits.",
                    tableHeading: "SPDR® Gold Shares ETF"
                },
                {
                    id: 4,
                    headText: "Nikkei 225 Index",
                    profileImg: "/img/education/japan_flag_svg.png",
                    text: "The Nikkei Stock Average, commonly referred to as the Nikkei 225 Index, is the most widely quoted average of Japanese equities . It is a price-weighted equity index (the unit is yen), which consists of 225 stocks in the 1st section of the Tokyo Stock Exchange, and the components are reviewed once a year.</br></br>In 1986, SGX pioneered the world's first futures contract based on the Japanese stock market -- the SGX Nikkei 225 Index Futures. The SGX Nikkei 225 Index is actively traded by participants all over the globe, and remains the dominant offshore Nikkei market during Asia trading hours",
                    img1: "/img/education/img4.png",
                    img2: "/img/education/img5.png",
                    img3: "/img/education/img6.png",
                    text1: "Indicator of Japanese stock market movements",
                    text2: "",
                    text3: "Actively traded futures index listed on the SGX",
                    text4: "is the dominant offshore Nikkei market during Asia trading hours",
                    text5: "Trades extended hours until 515AM and during Japanese holidays",
                    text6: "with the exception of New Year’s Day (1 January)",
                    tableHeading: "Nikkei 225"
                },                
                {
                    id: 5,
                    headText: "The NASDAQ-100 Index",
                    profileImg: "/img/education/sflag_us.svg",
                    text: "The NASDAQ-100® Index (“NDX”) is one of the world’s distinguished large-cap growth indexes and is home to some of the world’s most innovative companies including Apple, Google, Intel and Tesla. The index includes 100 of the largest U.S. and international non-financial companies listed on the NASDAQ Stock Market based on market capitalization. The index reflects companies across major industry groups including computer hardware and software, telecommunications, retail/wholesale trade and biotechnology, and does not contain securities of financial or investment companies.",
                    img1: "/img/education/NASDAQ1.svg",
                    img2: "/img/education/NASDAQ2.svg",
                    img3: "/img/education/NASDAQ3.svg",
                    text1: "100 of the largest",
                    text2: "U.S. and international non-financial companies based on market capitalization",
                    text3: "Houses innovative companies",
                    text4: "such as Apple, Google and Tesla",
                    text5: "Heavy allocation",
                    text6: "to top performing industries like Technology and Consumer Services",
                    tableHeading: "NDX"
                },
                {
                    id: 6,
                    headText: "The Standard & Poor's 500 index",
                    profileImg: "/img/education/sflag_us.svg",
                    text: "The Standard & Poor's 500® Index (SP500) is widely regarded as the best single gauge of large-cap U.S. equities and is one of the most followed equity indices in the world. There is over USD 13.5 trillion benchmarked to the SP500 (as of 31 December 2020) and it captures approximately 80% of the U.S. market capitalization. The index tracks 500 of the largest companies listed on the New York Stock Exchange and the NASDAQ including, Apple Inc, Amazon, Johnson and Johnson, Microsoft Corp, Facebook Inc, etc.",
                    img1: "/img/education/S&P1.svg",
                    img2: "/img/education/S&P2.svg",
                    img3: "/img/education/S&P3.svg",
                    text1: "Trades 23 hours",
                    text2: "Trading in S&P 500® futures covers the full trading hours of Bursa Malaysia",
                    text3: "Over $13.5 trillion",
                    text4: "in assets benchmarked to the index",
                    text5: "Captures ≈ 80%",
                    text6: "of U.S. equity market capitalization",
                    tableHeading: "S&P 500"
                },
                {
                    id: 7,
                    headText: "Amova Singapore STI ETF (SGX: G3B)",
                    profileImg: "/img/education/singapore_flag_svg.png",
                    text: "The Amova Singapore STI ETF is an exchange-traded fund (ETF) designed to track as closely as possible, before expenses, the performance of the Straits Times Index (STI), Singapore's benchmark stock market index. The STI comprises 30 of the largest and most liquid companies listed on the Singapore Exchange (SGX), providing investors with broad exposure to Singapore's blue-chip equity market. <br/><br/>Some of the ETF's largest holdings as of 30 June 2026 include:<br/><br/>• DBS<br/>• OCBC<br/>• UOB<br/>• SingTel<br/>• SGX<br/>• ST Engineering<br/>• Keppel<br/><br/><i>* Source: ETF factsheet from Amova Asset Management Asia Limited as of 30 June 2026<i/>",
                    img1: "/img/education/image3435.png",
                    img2: "/img/education/ribbon.png",
                    img3: "/img/education/image3436.png",
                    text1: "One of Singapore’s most popular ETFs listed on the SGX ",
                    text2: "",
                    text3: "Tracks top 30 listed companies in Singapore ",
                    text4: "",
                    text5: "Diversified exposure to various sectors",
                    text6: "including financials, industrials, telecommunications, real estate and consumer businesses ",
                    tableHeading: "Amova STI ETF"
                },
                {
                    id: 8,
                    headText: "Lion-Phillip S-REIT ETF (SGX: CLR)",
                    profileImg: "/img/education/singapore_flag_svg.png",
                    text: "The Lion-Phillip S-REIT ETF is Singapore's first REIT-focused ETF. It seeks to closely track, before fees and expenses, the Morningstar® Singapore REIT Yield Focus IndexSM, providing investors with exposure to a portfolio of Singapore-listed Real Estate Investment Trusts (S-REITs) selected based on dividend yield, quality and financial health criteria. <br/><br/>Major constituents on the ETF as of 30 June 2026 include:<br/><br/>• CapitaLand Integrated Commercial Trust<br/>• Mapletree Logistics Trust<br/>• CapitaLand Ascendas REIT<br/>• Keppel DC REIT<br/>• Mapletree Pan Asia Commercial Trust<br/>• Keppel REIT<br/>• Mapletree Industrial Trust<br/>• Frasers Logistics & Commercial Trust<br/>• Suntec REIT<br/>• Frasers Centrepoint Trust<br/><br/><i>* Source:  ETF factsheet from Lion Global Investors as of 30 June 2026<i/>",
                    img1: "/img/education/image1231.png",
                    img2: "/img/education/image1232.png",
                    img3: "/img/education/image123123.png",
                    text1: "Diversified basket of Singapore REIT names",
                    text2: "",
                    text3: "Access to multiple real estate segments",
                    text4: "including commercial, industrial, logistics, retail, hospitality and specialised real estate sector",
                    text5: "Focus on high quality REITs using Morning star’s methodology ",
                    text6: "",
                    tableHeading: "Lion-Phillip SREITS ETF"
                },
                {
                    id: 9,
                    headText: "iShares FTSE China A50 ETF",
                    profileImg: "/img/education/sflag_cn.svg",
                    text: "The iShares FTSE China A50 ETF (“China A50 ETF”) is an exchange traded fund listed on the Stock Exchange of Hong Kong (SEHK), whose movement closely corresponds to the performance of the FTSE China A50 Index. The index is designed to represent the performance of the mainland Chinese market through the 50 largest A Share companies listed on the Shanghai and Shenzhen stock exchanges.",
                    img1: "/img/education/China1.svg",
                    img2: "/img/education/China2v2.png",
                    img3: "/img/education/China3.svg",
                    text1: "Net assets",
                    text2: "of over RMB15 billion",
                    text3: "FTSE China A50 Index",
                    text4: "comprises the top 50 A-Share companies by market capitalization",
                    text5: "Provides access",
                    text6: "to movements in the China A-Share market",
                    tableHeading: "China A50 ETF"
                },
            ],
            showModaData: {},
            call: [],
            put: [],
            ranking: [],
            alertResult: {
                data: []
            },
            currencyType: null

        }
    }
    componentDidMount() {
        this.setState({
            showModaData: this.state.modalData[this.props.keyValue - 1]
        })
        this.getAlertData(this.props.keyValue)
        this.getWarrantData(this.props.keyValue)
        this.getIndexData(this.props.keyValue)

    }
    getChartOption() {
        const array1 = [];
        const array2 = [];
        let currName = '';
        if (typeof this.state.alertResult.data == 'string') {
            const temp = (this.state.alertResult.data).split("|")
            const array = temp
            currName = this.state.currencyType

            for (let i = 0; i < array.length; i++) {
                const split = array[i].split(";");
                array1.push(split[0]);
                array2.push(Number(split[1]));
            }
            // const array3 = array1

        } else {
            currName = this.state.currencyType
            for (let i = 0; i < this.state.alertResult.data.length; i++) {
                array1.push(this.state.alertResult.data[i].time);
                array2.push(Number(this.state.alertResult.data[i].close));
            }
        }
        const array3 = array1
        const options = {

            lang: {
                thousandsSep: ','
            },
            chart: {
                type: "area",
            },
            title: {
                text: "",
            },
            subtitle: {
                text: "",
            },
            credits: {
                text: "",
            },
            graphs: {
                fillAlphas: 0.2,
                fillColors: "#097CCF",
                lineColor: "#097CCF",
                negativeFillAlphas: 0,
            },
            tooltip: {
                useHTML: true,
                borderColor: '#097CCF',
                borderWidth: 2,
                style: {
                    fontWeight: 800,
                    fontSize: 13,
                    zIndex: 100,
                },
                //pointFormat: `<b>Underlying Price (${currName}) :</b> {point.y:.f}`,
                formatter: function () {
                    // The first returned item is the header, subsequent items are the
                    // points
                    return ['<b>' + this.x + '</b>'].concat(
                        this.points ?
                            this.points.map(function (point) {
                                return '<b>Underlying Price (' + currName + '): ' + point.y.toLocaleString();
                            }) : []
                    );
                },
                split: true,
                xDateFormat: '%d/%m/%y'
            },
            xAxis: {
                categories: array3.map((d) => moment(d).format("DD/MM")),
                tickInterval: 33,
                title: {
                    text: "",
                },
                crosshair: {
                    width: 1,
                    color: "red",
                    zIndex: "10",
                },
                gridLineColor: "#FAFAFA",
                gridLineWidth: 1,

            },
            yAxis: {
                lineWidth: 1,
                tickWidth: 1,
                gridLineColor: "#FAFAFA",
                gridLineWidth: 1,
                floor: Math.min(...array2),
                categories: array2.map((d) => d),
                tickInterval: Math.min(...array2) >= 4000 ? 1000 : (Math.min(...array2) < 4000 && Math.min(...array2) > 3400) ? 400 : (Math.min(...array2) < 3399 && Math.min(...array2) > 1300) ? 30 : 2,
                title: {
                    text: "",
                },
                labels: {
                    formatter: function () {
                        return this.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    },
                },
            },
            plotOptions: {
                area: {
                    lineWidth: 1,
                    lineColor: '#097CCF',
                    marker: {
                        enabled: true,
                        symbol: "circle",
                        radius: 0,
                        states: {
                            hover: {
                                enabled: false,
                                lineWidth: 0,
                                lineWidthPlus: 0,
                                radius: 0,
                                radiusPlus: 0
                            },
                        },
                    },
                    series: {
                        stacking: "normal",
                    },
                },
            },
            series: [{
                showInLegend: false,
                name: "",
                animation: false,
                fillColor: "#cce3f3",
                data: array2,
            }]
        }
        return options
    }
    getAlertData(keyValue) {
        let ric = null;
        switch (keyValue) {
                case 1:
                    ric='HSIc1';
                    break;
                case 2:
                    ric='HHTIc1';
                    break;
                case 3:
                    ric='SGLD.SI';
                    break;
                case 4:
                    ric='SSIcv1';
                    break;
                case 5:
                    ric='NQc1';
                    break;
                case 6:
                    ric='ESc1';
                    break;
                case 7:
                    ric='AMOE.SI';
                    break;
                case 8:
                    ric='LIOP.SI';
                    break;
                case 9:
                    ric='2823.HK';
                    break;
                default:
                    null
            }
        const qid = Date.now()
        const url =
            MQSGUtil.getAPIBasePath() + "/alert?TYPE=JSON&RIC=" + ric + "&PERIODICITY=Y&d=" + qid;
        fetch(url)
            .then((res) => {
                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }
                return res.json();
            })
            .then(
                (result) => {
                const arry = process.env.REACT_APP_UNDERILING?.split(",") || [];
                let needModifyBID = false;
                    if (typeof ric === 'string' && ric.trim()) {
                        for (const item of arry) {
                            if (item.trim() === ric.trim()) { 
                                needModifyBID = true;
                                break;
                            }
                        }
                    }
                    if (!needModifyBID && arry.includes("HK")) {
                        if (typeof ric === 'string' && ric.trim() && ric.trim().toLowerCase().endsWith(".hk")) {
                            needModifyBID = true;
                        }
                    }
                    if (!needModifyBID && arry.includes(".O")) {
                        if (typeof ric === 'string' && ric.trim() && ric.trim().toLowerCase().endsWith(".o")) {
                            needModifyBID = true;
                        }
                    }
                    if (needModifyBID) {
                        const processData = (originalData) => {
                        return {
                            ...originalData,
                            data: []
                        };
                        };
                        this.setState({ alertResult: processData(result)})
                    }else{
                        this.setState({ alertResult: result })
                    }
                },
                (error) => {
                    this.setState({ alertResult: { data: [] } });
                }
            );
    }
    getWarrantData(keyValue) {
        const qid = Date.now()
        const url =
            MQSGUtil.getAPIBasePath() + "/MarketDataJSON?type=index_sortbyname&lmt=all&qid=" + qid;
        fetch(url)
            .then((res) => res.json())
            .then(
                (result) => {
                    const warrantIssue = result.ranking
                    const newData = warrantIssue.filter((d) => d.underlying_ticker === "HSI")
                    const newData2 = warrantIssue.filter((d) => d.underlying_ticker === "HSTECH")
                    const newData3 = warrantIssue.filter((d) => d.underlying_ticker === "O87")
                    const newData4 = warrantIssue.filter((d) => d.underlying_ticker === "N225")
                    const newData5 = warrantIssue.filter((d) => d.underlying_ticker === "S&P500")
                    const newData6 = warrantIssue.filter((d) => d.underlying_ticker === "NDX")
                    const newData7 = warrantIssue.filter((d) => d.underlying_ticker === "G3B")
                    const newData8 = warrantIssue.filter((d) => d.underlying_ticker === "CLR")
                    const newData9 = warrantIssue.filter((d) => d.underlying_ticker === "ISHARES A50")
                    let arr = []
                    switch (keyValue) {
                        case 1:
                            arr=newData;
                            break;
                        case 2:
                            arr=newData2;
                            break;
                        case 3:
                            arr=newData3;
                            break;
                        case 4:
                            arr=newData4;
                            break;
                        case 5:
                            arr=newData6;
                            break;
                        case 6:
                            arr=newData5;
                            break;
                        case 7:
                            arr=newData7;
                            break;
                        case 8:
                            arr=newData8;
                            break;
                        case 9:
                            arr=newData9;
                            break;
                        default:
                            arr=[]
                    }
                    this.setState({
                        ranking: arr
                    })
                },
                (error) => {

                }
            );
    }
    getIndexData(keyValue) {
            let ticker = null;
            switch (keyValue) {
                case 1:
                    ticker='HSI';
                    break;
                case 2:
                    ticker='HSTECH';
                    break;
                case 3:
                    ticker='O87';
                    break;
                case 4:
                    ticker='N225';
                    break;
                case 5:
                    ticker='NDX';
                    break;
                case 6:
                    ticker='S%26P500';
                    break;
                case 7:
                    ticker='G3B';
                    break;
                case 8:
                    ticker='CLR';
                    break;
                case 9:
                    ticker='2823.HK';
                    break;
                default:
                    null
            }
        let qid = Date.now()
        const url =
            MQSGUtil.getAPIBasePath() + "/IndexWarrantsJSON?ticker=" + ticker + "&qid=" + qid;
        fetch(url)
            .then((res) => res.json())
            .then(
                (result) => {
                    if (result.CALL.length == 0) {
                        return;
                    }
                    const currType = result.CALL[0].underlying_ric;
                    let type = '';
                    if (currType == "ESc1") {
                        type = "USD"
                    } else if (currType == "NQc1") {
                        type = "USD"
                    } else if (currType == "YMc1") {
                        type = "USD"
                    } else if (currType == "FKLIc1") {
                        type = "MYR"
                    } else if (currType == 'SSIcv1') {
                        type = "JPY"
                    } else if (currType == 'SSGc1') {
                        type = "SGD"
                    } else {
                        type = "HKD"
                    }
                    this.setState({
                        call: result.CALL,
                        put: result.PUT,
                        currencyType: type
                    })
                },
                (error) => {

                }
            );
    }
    setOpen() {
        this.props.setValue(false)
    }
    render() {
        const style = {
            width: "300px",
            height: "470px",
        };
        return (
            <div id="ppBoxHTML1" className="overlay indexModal" style={{ display: this.props.show ? 'block' : 'none' }}>
                <div className="overlay-inner" style={{ background: '#F5F6F7', width: '85%' }}>
                    <div style={{ position: 'relative' }}>
                        <img
                            className="btn-close"
                            style={{}}
                            src="/img/education/icon-close-black.png"
                            onClick={() => this.setOpen(false)}
                        />
                        <div className="popupbox-content" style={{ paddingLeft: '15px', paddingRight: '15px' }}><div className="ppc" key="What-is-NDX">
                            <div className="row">
                                <div className="col-sm-12" style={{ display: 'flex', alignItems: 'flex-start' }}>
                                    <img
                                        src={this.state.showModaData?.profileImg}
                                        style={{ width: '60px', paddingRight: '10px', margin: '0px' }} />
                                    <h2 className="ppc-h">{this.state.showModaData?.headText}</h2><h2>
                                    </h2></div>
                                <div className="col-sm-12" style={{ marginTop: '10px' }}>
                                    <p  dangerouslySetInnerHTML={{ __html: this.state.showModaData !== undefined ? this.state.showModaData.text : "", }}>

                                    </p>
                                </div>
                                <div className="col-sm-12" style={{ marginTop: '10px', display: 'flex', flexWrap: 'wrap' }}>
                                    <div className="row rating-row mdHeight" style={{height:'auto'}}>
                                        <div className="col-md-4 " style={{ paddingLeft: '0px' }}>
                                            <div className="rating-item">
                                                <div className="rating-img"><img src={this.state.showModaData?.img1} /></div>
                                                <div className="rating-item-txtarea">
                                                    <h4 className="rating-item-ttl" style={{ fontWeight: 'bold' }}>
                                                        {this.state.showModaData?.text1}
                                                    </h4>
                                                    <p className="rating-item-txt" dangerouslySetInnerHTML={{ __html: this.state.showModaData !== undefined ? this.state.showModaData.text2 : "", }}></p>
                                                    {/* <p className="rating-item-txt">
                                                        {this.state.showModaData?.text2}
                                                    </p> */}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="rating-item">
                                                <div className="rating-img"><img src={this.state.showModaData?.img2} style={{width:this.state.showModaData?.id === 8 ?'75px':this.state.showModaData?.id === 7 ?'65px':'50px',height:this.state.showModaData?.id === 8 ?'35px':this.state.showModaData?.id === 7 ? '55px':'50px'  }} /></div>
                                                <div className="rating-item-txtarea">
                                                    <h4 className="rating-item-ttl" style={{ fontWeight: 'bold' }}>
                                                        {this.state.showModaData?.text3}
                                                    </h4>
                                                    <p className="rating-item-txt">
                                                        {this.state.showModaData?.text4}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="rating-item">
                                                <div className="rating-img"><img  src={this.state.showModaData?.img3} style={{width:this.state.showModaData?.id === 7 ?'60px':'50px',height:this.state.showModaData?.id === 7 ?'60px':'50px'  }}/></div>
                                                <div className="rating-item-txtarea">
                                                    <h4 className="rating-item-ttl" style={{ fontWeight: 'bold' }}>
                                                        {this.state.showModaData?.text5}
                                                    </h4>
                                                    <p className="rating-item-txt">
                                                        {this.state.showModaData?.text6}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="call_table col-xs-12" style={{}}>
                                    <div className="tw_table row">
                                        <p className="tw_table_p" style={this.state.call?.length === 0 && this.state.put?.length === 0 ? { display: 'none' } : {}}>Trending warrants with the highest liquidity and tightest spreads</p>
                                        <div className="call_td_0 call_td col-md-3 mdPadding" style={this.state.call?.length === 0 ? { display: 'none' } : {}} >
                                            <div className="tw_warrant">
                                                <div colSpan={2} className="tw_title">
                                                    <div className="tw_type">Call</div>
                                                    <div className="tw_ticker">
                                                        {this.state.call?.map((d) => d.dsply_nmll)[0]}
                                                        <br />
                                                        {'('+this.state.call?.map((d) => d.ticker)[0]+')'}
                                                    </div>
                                                </div>
                                                <table style={{ width: '100%' }}>
                                                    <tbody>
                                                        <tr>
                                                            <td style={{ width: '40%' }}>
                                                                Price:
                                                            </td>
                                                            <td style={{ width: '60%' }}>
                                                                SGD <span className="tw_BID">{this.state.call?.map((d) => Number(d.BID).toFixed(3))[0]}</span> <br />
                                                                (<span
                                                                    className={this.state.call.length > 0 && this.state.call[0].BID_PCTCHNG && this.state.call[0].BID_PCTCHNG.toString() <= 0 ? "tw_BID_PCTCHNG down" : "tw_BID_PCTCHNG up"}
                                                                >{this.state.call.length > 0 && this.state.call[0].BID_PCTCHNG ? `${parseFloat(this.state.call[0].BID_PCTCHNG).toFixed(1)}%` : "-"}
                                                                </span>)
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: '40%' }}>
                                                                Strike:
                                                            </td>
                                                            <td className="tw_strike" style={{ width: '60%' }}>{this.state.call?.map((d) => d.exercise_price)[0]}</td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: '40%' }}>
                                                                Expiry:
                                                            </td>
                                                            <td className="tw_expiry" style={{ width: '60%' }}>{moment(this.state.call?.map((d) => d.maturity)[0]).format('DD MMM YY')}</td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: '40%' }}>
                                                                Eff gearing:
                                                            </td>
                                                            <td className="tw_eff" style={{ width: '60%' }}>{this.state.call && this.state.call[0] && this.state.call[0].effective_gearing ? parseFloat(this.state.call[0].effective_gearing).toFixed(1) : "-"}</td>
                                                        </tr>
                                                    </tbody></table>
                                                <Link className={`viewLM ${this.state.call?.map((d) => d.ticker)[0]}`} target="_blank" to={`/tools/livematrix/${this.state.call?.map((d) => d.ticker)[0]}`}>
                                                    <div className="vlmbtn bgcolor-06 btn" style={{ backgroundColor: "#fecc0a" }}>
                                                        View matrix
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="put_td_0 put_td col-md-3" style={this.state.put?.length === 0 ? { display: 'none' } : {}}>
                                            <div className="tw_warrant">
                                                <div colSpan={2} className="tw_title">
                                                    <div className="tw_type">Put</div>
                                                    <div className="tw_ticker">
                                                        {this.state.put?.map((d) => d.dsply_nmll)[0]}
                                                        <br />
                                                        {'('+this.state.put?.map((d) => d.ticker)[0]+')'}
                                                    </div>
                                                </div>
                                                <table style={{ width: '100%' }}>
                                                    <tbody><tr>
                                                        <td style={{ width: '40%' }}>
                                                            Price:
                                                        </td>
                                                        <td style={{ width: '60%' }}>
                                                            SGD <span className="tw_BID">
                                                                {this.state.put?.map((d) => Number(d.BID).toFixed(3))[0]}</span> <br />
                                                            (<span
                                                                className={this.state.put.length > 0 && this.state.put[0].BID_PCTCHNG && this.state.put[0].BID_PCTCHNG.toString() <= 0 ? "tw_BID_PCTCHNG down" : "tw_BID_PCTCHNG up"}
                                                            >
                                                                {this.state.put.length > 0 && this.state.put[0].BID_PCTCHNG ? parseFloat(this.state.put[0].BID_PCTCHNG).toFixed(1) + "%" : "-"}

                                                            </span>)
                                                        </td>
                                                    </tr>
                                                        <tr>
                                                            <td style={{ width: '40%' }}>
                                                                Strike:
                                                            </td>
                                                            <td className="tw_strike" style={{ width: '60%' }}>{this.state.put?.map((d) => d.exercise_price)[0]}</td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: '40%' }}>
                                                                Expiry:
                                                            </td>
                                                            <td className="tw_expiry" style={{ width: '60%' }}>{moment(this.state.put?.map((d) => d.maturity)[0]).format('DD MMM YY')}</td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: '40%' }}>
                                                                Eff gearing:
                                                            </td>
                                                            <td className="tw_eff" style={{ width: '60%' }}>
                                                                {this.state.put && this.state.put[0] && this.state.put[0].effective_gearing ? parseFloat(this.state.put[0].effective_gearing).toFixed(1) : "-"}
                                                            </td>
                                                        </tr>
                                                    </tbody></table>
                                                <Link className={`viewLM ${this.state.put?.map((d) => d.ticker)[0]}`} target="_blank" to={`/tools/livematrix/${this.state.put?.map((d) => d.ticker)[0]}`}>
                                                    <div className="vlmbtn bgcolor-06 btn" style={{ backgroundColor: "#fecc0a" }}>
                                                        View matrix
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="call_td_1 call_td col-md-3" style={this.state.call?.length < 2 ? { display: 'none' } : {}}>
                                            <div className="tw_warrant">
                                                <div colSpan={2} className="tw_title">
                                                    <div className="tw_type">Call</div>
                                                    <div className="tw_ticker">
                                                        {this.state.call?.map((d) => d.dsply_nmll)[1]}
                                                        <br />
                                                        {'('+this.state.call?.map((d) => d.ticker)[1]+')'}
                                                    </div>
                                                </div>
                                                <table style={{ width: '100%' }}>
                                                    <tbody><tr>
                                                        <td style={{ width: '40%' }}>
                                                            Price:
                                                        </td>
                                                        <td style={{ width: '60%' }}>
                                                            SGD <span className="tw_BID">
                                                                {this.state.call?.map((d) => Number(d.BID).toFixed(3))[1]}
                                                            </span> <br />
                                                            (<span
                                                                className={this.state.call && this.state.call[1]?.BID_PCTCHNG && this.state.call[1]?.BID_PCTCHNG.toString() <= 0 ? "tw_BID_PCTCHNG down" : "tw_BID_PCTCHNG up"}
                                                            >
                                                                {this.state.call && this.state.call[1]?.BID_PCTCHNG ? `${parseFloat(this.state.call[1]?.BID_PCTCHNG).toFixed(1)}%` : "-"}
                                                            </span>)
                                                        </td>
                                                    </tr>
                                                        <tr>
                                                            <td style={{ width: '40%' }}>
                                                                Strike:
                                                            </td>
                                                            <td className="tw_strike" style={{ width: '60%' }}>{this.state.call?.map((d) => d.exercise_price)[1]}</td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: '40%' }}>
                                                                Expiry:
                                                            </td>
                                                            <td className="tw_expiry" style={{ width: '60%' }}>{moment(this.state.call?.map((d) => d.maturity)[1]).format('DD MMM YY')}</td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: '40%' }}>
                                                                Eff gearing:
                                                            </td>
                                                            <td className="tw_eff" style={{ width: '60%' }}>
                                                                {this.state.call && this.state.call[1] && this.state.call[1].effective_gearing ? parseFloat(this.state.call[1].effective_gearing).toFixed(1) : "-"}
                                                            </td>
                                                        </tr>
                                                    </tbody></table>
                                                <Link className={`viewLM ${this.state.call?.map((d) => d.ticker)[1]}`} target="_blank" to={`/tools/livematrix/${this.state.call?.map((d) => d.ticker)[1]}`}>
                                                    <div className="vlmbtn bgcolor-06 btn" style={{ backgroundColor: "#fecc0a" }}>
                                                        View matrix
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="put_td_1 put_td col-md-3" style={this.state.put?.length < 2 ? { display: 'none' } : {}}>
                                            <div className="tw_warrant">
                                                <div colSpan={2} className="tw_title">
                                                    <div className="tw_type">Put</div>
                                                    <div className="tw_ticker">
                                                        {this.state.put?.map((d) => d.dsply_nmll)[1]}
                                                        <br />
                                                        {'('+this.state.put?.map((d) => d.ticker)[1]+')'}
                                                    </div>
                                                </div>
                                                <table style={{ width: '100%' }}>
                                                    <tbody>
                                                        <tr>
                                                            <td style={{ width: '40%' }}>
                                                                Price:
                                                            </td>
                                                            <td style={{ width: '60%' }}>
                                                                SGD <span className="tw_BID">
                                                                    {this.state.put?.map((d) => Number(d.BID).toFixed(3))[1]}
                                                                </span> <br />
                                                                (<span
                                                                    className={this.state.put.length > 1 && this.state.put[1].BID_PCTCHNG && this.state.put[1].BID_PCTCHNG.toString() <= 0 ? "tw_BID_PCTCHNG down" : "tw_BID_PCTCHNG up"}
                                                                >
                                                                    {this.state.put.length > 1 && this.state.put[1].BID_PCTCHNG ? parseFloat(this.state.put[1].BID_PCTCHNG).toFixed(1) + "%" : "-"}

                                                                </span>)
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: '40%' }}>
                                                                Strike:
                                                            </td>
                                                            <td className="tw_strike" style={{ width: '60%' }}>{this.state.put?.map((d) => d.exercise_price)[1]}</td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: '40%' }}>
                                                                Expiry:
                                                            </td>
                                                            <td className="tw_expiry" style={{ width: '60%' }}>{moment(this.state.put?.map((d) => d.maturity)[1]).format('DD MMM YY')}</td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: '40%' }}>
                                                                Eff gearing:
                                                            </td>
                                                            <td className="tw_eff" style={{ width: '60%' }}>{this.state.put && this.state.put[1] && this.state.put[1].effective_gearing ? parseFloat(this.state.put[1].effective_gearing).toFixed(1) : "-"}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <Link className={`viewLM ${this.state.put?.map((d) => d.ticker)[1]}`} target="_blank" to={`/tools/livematrix/${this.state.put?.map((d) => d.ticker)[1]}`}>
                                                    <div className="vlmbtn bgcolor-06 btn" style={{ backgroundColor: "#fecc0a" }}>
                                                        View matrix
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* {(this.state.showModaData.id ===4) && <div className="col-sm-12" style={{ clear: 'both' }}>
                                    <div id="chartbox" style={{ width: '100%', overflow: 'hidden', textAlign: 'left' }}>
                                        <div style={{ position: 'relative' }}>
                                            <div style={{ overflow: 'hidden', position: 'relative', textAlign: 'left', cursor: 'default', width: '100%' }}>
                                                {this.state.alertResult && <HighchartsReact
                                                    highcharts={Highcharts}
                                                    options={this.getChartOption()}
                                                    style={style}
                                                />}
                                            </div>
                                        </div></div>
                                </div>} */}
                                {/* {(this.state.showModaData.id ===4)  && <Link className={`viewC ${this.state.ranking?.map((d) => d.underlying_ticker)[0]}`}
                                    target="_blank"
                                    to={`/tools/underlying/${this.state.ranking?.map((d) => d.underlying_ticker)[0]}`}>
                                    <div className="vcbtn bgcolor-06 btn" style={{ position:'relative',float:'right',marginTop:'15px' }}>View charts</div>
                                </Link>} */}
                                <div className="col-sm-12" style={{ clear: 'both' }}>
                                    <h2 className='table-heading'>{this.state.showModaData?.tableHeading} warrants issued by Macquarie</h2>
                                    <table id="warranttbl" className="table table-striped table-closed table-responsive">
                                        <thead>
                                            <tr>
                                                <th>Warrant Name</th>
                                                {/* <th>Underlying</th> */}
                                                <th>Type</th>
                                                <th className="hidden-xs">Last bid price</th>
                                                <th className="hidden-xs">Change</th>
                                                <th className="hidden-xs">Change (%)</th>
                                                <th className="hidden-xs">Volume ('000)</th>
                                                <th>Expiry</th>
                                                <th className="hidden-xs">Last trading date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.ranking && this.state.ranking.map((d) =>
                                                <tr className="rowtmpl" idx={0}>
                                                    <td className="col_dsply_nmll"><a target="_blank" href={`/tools/livematrix/${d.ticker}`}>{d.dsply_nmll+' ('+d.ticker+')'}</a></td>
                                                    {/* <td className="col_underlying_ticker"><a target="_blank" href={`/my/tools/underlying/${d.underlying_ric}`}>{d.underlying_ticker}</a></td> */}
                                                    <td className="col_type">{d.type == 'PUT' ? "P" : 'C'}</td>
                                                    <td className="hidden-xs col_BID">{MQSGUtil.formatNumberDisplay(d.BID, 3)}</td>
                                                    <td className={d.BID_NETCHNG.includes("-") ? "hidden-xs col_BID_NETCHNG down" : "hidden-xs col_BID_NETCHNG up"}>{MQSGUtil.formatNumberDisplay(d.BID_NETCHNG, 2)}</td>
                                                    <td className={d.BID_PCTCHNG.includes("-") ? "hidden-xs col_BID_PCTCHNG down" : "hidden-xs col_BID_PCTCHNG up"}>{MQSGUtil.formatNumberDisplay(d.BID_PCTCHNG, 2)}</td>
                                                    <td className="hidden-xs col_ACVOL_1_SCALED">{MQSGUtil.formatNumberDisplay(d.ACVOL_1_SCALED)}</td>
                                                    <td className="col_maturity">{d.maturity}</td>
                                                    <td className="hidden-xs col_last_trading_date">{d.last_trading_date}</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                    <p className="underlying_note">
                                        Last updated: {new Date().toLocaleString('en-GB', {
                                            day: 'numeric',
                                            month: 'short',
                                            year: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            hour12: false
                                            }).replace(',', '') }
                                    </p>
                                    <p className="underlying_note">
                                        All market data is delayed 15 mins unless otherwise indicated by timestamp.
                                    </p>
                                </div>
                            </div>
                        </div></div>
                    </div>
                </div>
            </div>
        )
    }

}